import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerComponent } from './progress-spinner/progress-spinner.component';
import { MaterialsModule } from '../materials/materials.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ChangeImageComponent } from './change-image/change-image.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { EllipsisTooltipDirective } from './directives/ellipsis-tooltip.directive';

@NgModule({
    declarations: [ProgressSpinnerComponent, AlertDialogComponent, ConfirmDialogComponent, ChangeImageComponent],
    imports: [
        CommonModule,
        MaterialsModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        ImageCropperComponent,
        EllipsisTooltipDirective
    ],
    providers: [{ provide: MatDialogRef, useValue: {} }]
})
export class SharedModule { }
